import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Products from '../components/Products';
import Partners from '../components/Partners';
import Cases from '../components/Cases';
import CTA from '../components/CTA';

type HomeNavState = {
  scrollTo?: string;
};

const HomePage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const state = (location.state ?? {}) as HomeNavState;
    const scrollTo = state.scrollTo;
    if (!scrollTo) return;

    // 等待页面内容渲染后再滚动
    const timer = window.setTimeout(() => {
      const el = document.getElementById(scrollTo);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 50);

    return () => window.clearTimeout(timer);
  }, [location.key, location.state]);

  return (
    <>
      <Hero id="hero" />
      {/* <Features /> */}
      <Products id="products" />
      <Cases id="cases" />
      <Partners id="partners" />
      {/* <Industries /> */}
      <CTA id="cta" />
    </>
  );
};

export default HomePage;

